const $ = jQuery.noConflict()
var PROXY = require('./proxy.js')

var self = module.exports = {
  init: function(trigger) {
    self.events.change(trigger)
  },

  events: {
    change: function(trigger) {
      $(document).on('change', trigger, function(event) {
        if (typeof $(this).data('toggle') !== 'undefined') {
          self.service.toggle(this)
        }
      })
    }
  },

  service: {
    toggle: function(trigger) {
      var original = $(trigger).val()
      var updated = $(trigger).data('toggle')

      $(trigger).val(updated)
      $(trigger).data('toggle', original)

      if (typeof $(trigger).data('proxy') !== 'undefined') {
        var target = $(trigger).data('proxy')
        PROXY.service.change(target, updated)
      }
    }
  }
}
// toggle form selling and letting for lead magnet for multi form
$('input[type=radio][name=lead-val]').change(function () {
    if (this.value == 'resale') {
        $('.lead-magnet-split__selling').show();
        $('.lead-magnet-split__letting').hide();
        $('.selling-img').show();
        $('.lettings-img').hide();
    }
    else if (this.value == 'lettings') {
        $('.lead-magnet-split__selling').hide();
        $('.lead-magnet-split__letting').show();
        $('.lettings-img').show();
        $('.selling-img').hide();
    }
});

$('input[name=property-book-viewing-appointment-1-times]:checkbox').change(function(){
    var selectedValue = $(this).val();
     if(selectedValue == 'Evening'){
      if ($(this).is(':checked')) {
         $('.day-time').hide();
      $('.evening-time').show();
      }else{
         $('.day-time').show();
        $('.evening-time').hide();
      }
    }
});

